import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import ViewContainer from "../../../Componentes/Utils/ViewContainer";
import Formulario from "../../../Componentes/Utils/Formulario";
import FormComp from "../../../Componentes/FormComp";
import { useEffect, useState } from "react";
import axios from "axios";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import { FaArrowDown } from "react-icons/fa";
import Tabela2 from "../../../Componentes/Utils/Tabela2";
import { AiOutlineFilePdf, AiOutlineFileImage, AiOutlineFileWord, AiOutlineFileExcel, AiOutlineFileUnknown } from "react-icons/ai";

const Titulo = styled.h2`
    margin: 0;
    color: #333;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
`
const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    box-sizing: border-box;
    margin-bottom: 10px;
`
const ContainerColabs = styled.div`
    margin-top: 10px;
    width: 100%;
    height: 200px;
`
const ContainerAnexos = styled.div`
    width: 100%;
    p {
        font-size: 14px;
        font-weight: 500;
        color: #555;
        margin: 0 0 5px 5px;
    }
`
const ContainerAnexo = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    background-color: #f6f8fa;
    border: 1px solid #ccc;
    margin-bottom: 5px;
    border-radius: 10px;
`
const AnexoIconContainer = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-right: 10px;
    flex-shrink: 0;
    box-sizing: border-box;
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
`
const AnexoNome = styled.p`
    font-size: 14px;
    color: #333;
    margin: 0;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
const ContainerAnexoDownload = styled.div`
    margin: auto 0 auto auto;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #e0e0e0;
    transition: all 0.2s;
    &:hover {
        background-color: #d0d0d0;
        scale: 1.05;
    }
`
const IconeDownload = styled(FaArrowDown)`
    color: #555;
    width: 50%;
    height: 50%;
`

const AnexosMock = [
    { id: 1, url: "https://sistema/api/test/to/verify/width/attachment/path/to/file1.pdf" },
    { id: 2, url: "https://sistema/api/path/to/image1.png" },
    { id: 3, url: "https://sistema/api/path/to/document1.docx" }
]

const ModalViewDesvio = ({ mode = 'view', desvio, fechar, updateData }) => {

    console.log(desvio);

    const [saving, setSaving] = useState(false);
    const [anexos, setAnexos] = useState([]);
    const [colaboradores, setColaboradores] = useState([]);

    const fetchData = async () => {

        const [anexosRes, colabsRes] = await Promise.all([
            await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/GetAnexos/index.php?id=${desvio?.id}`, { withCredentials: true }),
            await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/GetColaboradores/index.php?id=${desvio?.id}`, { withCredentials: true })
        ])

        console.log(anexosRes.data);

        setColaboradores(colabsRes.data);
        setAnexos(anexosRes.data);

    }

    useEffect(() => {

        fetchData();

    }, [desvio]);

    const [acaoCorretiva, setAcaoCorretiva] = useState(desvio?.acao_corretiva || "");
    const [resolvido, setResolvido] = useState(desvio?.resolvido || 0);

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            setSaving(true);

            const formData = new FormData();
            formData.append("id", desvio.id);
            formData.append("acao_corretiva", acaoCorretiva);
            formData.append("resolvido", resolvido);

            const { data } = await axios.post("https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/UpdateDesvio/", formData, { withCredentials: true });
            console.log(data);

            updateData();
            fechar();

        } catch (e) {

            console.log(e);

        } finally {
            setSaving(false);
        }

    }

    const getFileIcon = (filename) => {
        const name = filename.toLowerCase();

        if (name.endsWith(".png") || name.endsWith(".jpg")) return <AiOutlineFileImage size={22} color="#4a90e2" />;
        if (name.endsWith(".pdf")) return <AiOutlineFilePdf size={22} color="#e63946" />;
        if (name.endsWith(".doc") || name.endsWith(".docx")) return <AiOutlineFileWord size={22} color="#2a6db0" />;
        if (name.endsWith(".xls") || name.endsWith(".xlsx")) return <AiOutlineFileExcel size={22} color="#207245" />;

        return <AiOutlineFileUnknown size={22} color="#555" />;

    }

    const downloadAnexo = async (url) => {

        try {

            // Pega pasta que vem antes do nome do arquivo
            const urlParts = url.split('/');
            const filename = urlParts[urlParts.length - 1];
            const pasta = urlParts[urlParts.length - 2];

            console.log(pasta)
            console.log(filename)

            const urlDownload = `https://sistemaintegrado.palmont.com.br/Painel/API/DownloadFile/index.php?pasta=${pasta}&file=${filename}`;

            const { data } = await axios.get(urlDownload, {
                responseType: 'blob',
                withCredentials: true
            });

            const urlBlob = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (e) {
            console.log(e);
        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={fechar} >
                    <Titulo>Visualizar Desvio</Titulo>
                    <Container>
                        <ViewContainer label="ID DESVIO" valor={desvio?.id} />
                        <ViewContainer label="CENTRO CUSTO" valor={desvio?.centro_custo} />
                        <ViewContainer label="CONTRATO" valor={desvio?.contrato} />
                        <ViewContainer label="DATA DO OCORRIDO" valor={desvio?.data_ocorrido} />
                        <ViewContainer label="ÁREA" valor={desvio?.area} />
                        <ViewContainer label="EQUIPE" valor={desvio?.equipe} />
                        <ViewContainer label="PROCESSO" valor={desvio?.processo} />
                        <ViewContainer label="CATEGORIA DO RISCO" valor={desvio?.categoria_risco} />
                        <ViewContainer label="TIPO DE RISCO" valor={desvio?.tipo_risco} />
                        <ViewContainer label="CLASSIFICAÇÃO DO DESVIO" valor={desvio?.classificacao_risco} />
                        <ViewContainer label="STATUS ACIDENTE" valor={desvio?.acidente_status} />
                        <ViewContainer label="ATO OU CONDIÇÃO INSEGURA" valor={desvio?.ato_condicao} />
                        <ViewContainer label="LÍDER IMEDIATO" valor={desvio?.lider_imediato} />
                        <ContainerColabs>
                            <Tabela2>
                                <thead>
                                    <tr>
                                        <th colSpan={3} >COLABORADORES ENVOLVIDOS</th>
                                    </tr>
                                    <tr>
                                        <th>MATRICULA</th>
                                        <th>NOME</th>
                                        <th>FUNÇÃO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        colaboradores.map((colab) => (
                                            <tr key={colab.matricula} >
                                                <td>{colab.matricula}</td>
                                                <td>{colab.nome}</td>
                                                <td>{colab.funcao}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Tabela2>
                        </ContainerColabs>
                        <ViewContainer label="OCORRÊNCIA" valor={desvio?.ocorrido} />

                        <ContainerAnexos>
                            <p>ANEXOS</p>
                            {
                                anexos.map((anexo) => (
                                    <ContainerAnexo key={anexo.id} >
                                        <AnexoIconContainer>
                                            {getFileIcon(anexo.filename)}
                                        </AnexoIconContainer>
                                        <AnexoNome>{anexo.filename}</AnexoNome>
                                        <ContainerAnexoDownload>
                                            <IconeDownload onClick={() => downloadAnexo(anexo.url)} />
                                        </ContainerAnexoDownload>
                                    </ContainerAnexo>
                                ))
                            }
                        </ContainerAnexos>

                        {
                            desvio?.resolvido === 1 ? (
                                <>
                                    <ViewContainer label="AÇÃO CORRETIVA" valor={desvio?.acao_corretiva} />
                                    <ViewContainer label="RESOLVIDO" valor="SIM" />
                                </>
                            ) : (
                                <>
                                    <Formulario onSubmit={handleSubmit} >
                                        <FormComp
                                            title="AÇÃO CORRETIVA"
                                            type="textarea"
                                            valor={acaoCorretiva}
                                            changeFunc={(e) => setAcaoCorretiva(e.target.value)}
                                        />
                                        <FormComp
                                            title="JÁ FOI RESOLVIDO?"
                                            type="select"
                                            obj
                                            options={[
                                                { value: 1, label: "SIM" },
                                                { value: 0, label: "NÃO" }
                                            ]}
                                            valor={resolvido}
                                            changeFunc={(e) => setResolvido(e.target.value)}
                                        />
                                        <FormComp
                                            type="submit"
                                            valor="SALVAR"
                                        />
                                    </Formulario>
                                </>
                            )
                        }
                    </Container>
                </Modal>
                {
                    saving && (
                        <>
                            <Overlay state={true} >
                                <Modal>
                                    <SmallLoading
                                        text="ATUALIZANDO DESVIO..."
                                    />
                                </Modal>
                            </Overlay>
                        </>
                    )
                }
            </Overlay>
        </>
    )
}

export default ModalViewDesvio;